import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    getMessages,
    getMessagesParameter,
    MessageCollectionModel,
} from "@tKgpco/Services/OrderDetailsMessageCollection";

type HandlerType = ApiHandler<getMessagesParameter, MessageCollectionModel[]>;

export const DispatchBeginLoadOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/Orders/BeginLoadMessages",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getMessages(props.apiParameter);
};

export const DispatchCompleteLoadOrders: HandlerType = props => {
    props.dispatch({
        type: "Data/Orders/CompleteLoadMessages",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [PopulateApiParameter, DispatchBeginLoadOrders, RequestDataFromApi, DispatchCompleteLoadOrders];

const loadOrderDetailsMessages = createHandlerChainRunner(chain, "loadOrderDetailsMessages");
export default loadOrderDetailsMessages;
